export enum StrategyCategorySource {
  FUND = 'Fund',
  PREMIALAB = 'Premialab',
  REFINITIV = 'Refinitiv',
}
